import { gsap } from 'gsap';

const cursorComponent = {
  schema: {
    fuseDuration: { default: 1000 },
  },

  init() {
    this.tweensValues = { fuseTweenValue: 0 };

    this.interactionCursor = document.getElementById('interactionCursor');
    this.interactionCursor.object3D.renderOrder = 10;
    this.interactionCursorHighlight = document.getElementById('interactionCursorHighlight');
    this.fuseCircle = document.getElementById('fuseCircle');

    this.el.addEventListener('fusing', this.pointFusing.bind(this));
    this.el.addEventListener('click', this.pointClicked.bind(this));
    this.el.addEventListener('mouseleave', this.pointLeave.bind(this));

    setTimeout(() => {
      this.replaceShader();
      this.showHideCursorHighlight(false);
    }, 200);
  },

  pointFusing() {
    //this.showHideCursorLoaderContainer(true);
    this.showHideCursorHighlight(true);
  },

  pointClicked() {
    //this.showHideCursorLoaderContainer(false);
    this.showHideCursorHighlight(false);
  },

  pointLeave() {
    //this.showHideCursorLoaderContainer(false);
    this.showHideCursorHighlight(false);
  },

  showHideCursorHighlight(newValue) {
    // console.warn('showHideCursorHighlight - newValue:', newValue);
    gsap.killTweensOf(this.interactionCursor.components.material.material);
    gsap.to(this.interactionCursor.components.material.material, {
      opacity: newValue ? 0 : 1,
      duration: 0.25,
      ease: newValue ? 'power1.in' : 'power1.out',
    });
    gsap.killTweensOf(this.interactionCursorHighlight.components.material.material);
    gsap.to(this.interactionCursorHighlight.components.material.material, {
      opacity: newValue ? 1 : 0,
      duration: 0.25,
      ease: newValue ? 'power1.out' : 'power1.in',
    });

    this.setFuseIndicatorMoving(newValue);
  },

  setFuseIndicatorMoving(newStatus) {
    if (this.fuseTwn) this.fuseTwn.kill();
    let maskValue;
    if (newStatus) {
      this.fuseTwn = gsap.fromTo(this.tweensValues,
        {
          fuseTweenValue: 0,
        },
        {
          fuseTweenValue: Math.PI * 2,
          duration: this.data.fuseDuration * 0.001,
          ease: 'sine.inOut',
          onUpdate: () => {
            if (this.fuseTwn) {
              // maskValue = `conic-gradient(from 0deg, rgb(166 0 255), #00fff9 ${this.tweensValues.fuseTweenValue}deg, #00000000 0deg)`;
              // this.fuseCircle.style.setProperty('-webkit-mask-image', maskValue);
              // this.fuseCircle.style.setProperty('mask-image', maskValue);
              this.interactionCursorHighlightCircle.components.material.material.uniforms.angle.value = this.tweensValues.fuseTweenValue;
            }
          },
          callbackScope: this,
        }
      );
    }
    else {
      this.fuseTwn = gsap.to(this.tweensValues,
        {
          fuseTweenValue: 0,
          duration: 0.3,
          ease: 'sine.out',
          onUpdate: () => {
            if (this.fuseTwn) {
              // maskValue = `conic-gradient(from 0deg, rgb(166 0 255), #00fff9 ${this.tweensValues.fuseTweenValue}deg, #00000000 0deg)`;
              // this.fuseCircle.style.setProperty('-webkit-mask-image', maskValue);
              // this.fuseCircle.style.setProperty('mask-image', maskValue);
              this.interactionCursorHighlightCircle.components.material.material.uniforms.angle.value = this.tweensValues.fuseTweenValue;
            }
          },
          callbackScope: this,
        }
      );
    }
  },

  replaceShader() {
    this.interactionCursorHighlightCircle = document.getElementById('interactionCursorHighlightCircle');

    // Vertex shader (no need to modify, it's a basic passthrough)
    const vertexShader = `
      varying vec2 vUv;
      void main() {
        vUv = uv;
        gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
      }
    `;

    // Fragment shader (modify this to add the radial mask)
    const fragmentShader = `
      varying vec2 vUv;
      uniform sampler2D inputTexture;
      uniform float angle; // Angle in radians (0 to 3.141592653589793)

      void main() {
        // Calculate the center of the texture (assumes the texture coordinates are in the range 0-1)
        vec2 center = vec2(0.5, 0.5);

        // Calculate the vector from the center to the current fragment position
        vec2 toFragment = vUv - center;

        // Calculate the angle between the vector to the fragment and the positive x-axis
        float fragmentAngle = atan(toFragment.y, toFragment.x);

        // Normalize the angle to be between 0 and 2*pi (0 and 3.141592653589793)
        fragmentAngle = mod(fragmentAngle, 2.0 * 3.141592653589793);

        // Calculate the transparency based on the angle
        // float transparency = smoothstep(0.0, angle, fragmentAngle);
        float transparency = 1.0 - step(angle, fragmentAngle); // Inverted mask effect

        // Sample the input texture and adjust the alpha value with the calculated transparency
        vec4 texColor = texture2D(inputTexture, vUv);
        texColor.a *= transparency; // Multiply alpha with the transparency

        gl_FragColor = texColor;
      }
    `;

    // Usage:
    const previousTexture = this.interactionCursorHighlightCircle.components.material.material.map;
    // Create a new THREE.ShaderMaterial and pass the uniforms and attributes to it
    const uniforms = {
      color: { value: new THREE.Color(0xeeee00) },
      opacity: { value: 1 },
      inputTexture: { value: previousTexture }, // Set the input texture here
      angle: { value: 0.01 }, // Set the initial angle (in radians, between 0 and 3.141592653589793) of the mask here
    };

    const material = new THREE.ShaderMaterial({
      uniforms: uniforms,
      vertexShader: vertexShader,
      fragmentShader: fragmentShader,
      transparent: true, // Enable transparency in the material
    });

    // Now you can use the 'material' with your mesh
    this.interactionCursorHighlightCircle.components.material.material = material;
    this.interactionCursorHighlightCircle.object3D.children[0].material = material;

    // this.interactionCursorHighlightCircle.components.material.material.uniforms.angle.value = 0.2;
    // this.interactionCursorHighlightCircle.components.material.material.uniforms.angle.needsUpdate = true;
    // this.interactionCursorHighlightCircle.components.material.material.uniformsNeedUpdate = true;
  },
};

export default cursorComponent;
